import {
  ADD_SINK_SUCCESS,
  CREATE_DATA_MAP_SUCCESS,
  DATA_MAP_CLEAR_SEARCH_RESULTS,
  DELETE_DATA_MAP_SUCCESS,
  GET_ALL_DATA_MAPS_SUCCESS,
  GET_DATA_MAPS_SUCCESS,
  GET_DATA_MAP_DOC_SUCCESS,
  GET_DATA_MAP_ENTRY_SUCCESS,
  GET_DATA_MAP_SAMPLES_SUCCESS,
  GET_DATA_MAP_SUCCESS,
  LOGOUT_COMPLETE,
  SET_DATA_MAP_SEARCH_TERM,
  UPDATE_DATA_MAP_DOC_SUCCESS,
  UPDATE_DATA_MAP_SUCCESS,
} from 'js/constants/actionTypes';
import { filter, forEach, isEmpty } from 'lodash';

const initialState = {
  listing: [], // paginated IDs
  byId: [], // all IDs received from the unpaginated GET call
  docById: {},
  schemas: {},
  samplesById: {},
  samples: {
    // the samples being shown currently
    id: 0, // data map id
    flat: [],
    lastUpdated: null,
  },
  searchResults: {
    // the search results being shown currently
    id: 0, // data map id
    flat: [],
    lastUpdated: null,
  },
  lastUpdated: null,
  error: null,
};

export const dataMapsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_DATA_MAPS_SUCCESS:
      return addDataMapsListing(state, action);

    case GET_ALL_DATA_MAPS_SUCCESS:
      return addDataMaps(state, action);

    case GET_DATA_MAP_SUCCESS:
    case CREATE_DATA_MAP_SUCCESS:
    case ADD_SINK_SUCCESS:
    case UPDATE_DATA_MAP_SUCCESS:
      return addDataMapSchemas(state, action);

    case DELETE_DATA_MAP_SUCCESS:
      return deleteDataMap(state, action);

    case GET_DATA_MAP_SAMPLES_SUCCESS:
      return addDataMapSamples(state, action);

    case GET_DATA_MAP_ENTRY_SUCCESS:
      return addSearchResults(state, action);

    case GET_DATA_MAP_DOC_SUCCESS:
    case UPDATE_DATA_MAP_DOC_SUCCESS:
      return saveDataMapDoc(state, action);

    case SET_DATA_MAP_SEARCH_TERM:
      return handleUpdateSearchTerm(state, action);

    case DATA_MAP_CLEAR_SEARCH_RESULTS:
      return clearSearchResults(state, action);

    case LOGOUT_COMPLETE:
      return initialState;

    default:
      return state;
  }
};

export default dataMapsReducer;

function addDataMaps(state, action) {
  const { result } = action;

  return {
    ...addDataMapSchemas(state, action),
    byId: result,
  };
}

function getSchema(id, dataMap) {
  let { map_primary_key, map_entry_schema } = dataMap;
  let dm = {
    properties: [],
    secondaryProperties: [],
  };

  if (map_entry_schema && map_entry_schema.properties) {
    dm.properties = Object.keys(map_entry_schema.properties);
    let primaryKeyIndex = dm.properties.indexOf(map_primary_key);

    if (primaryKeyIndex > -1) {
      dm.properties.splice(primaryKeyIndex, 1);
      dm.properties.unshift(map_primary_key);
    }

    dm.secondaryProperties = dm.properties.filter((k) => k !== map_primary_key);
  }

  return dm;
}

function addDataMapsListing(state, action) {
  const { result } = action;

  return {
    ...state,
    listing: result,
  };
}

function addDataMapSchemas(state, action) {
  const {
    entities: { dataMaps },
  } = action;
  let schemas = {};

  forEach(dataMaps, (dataMap, id) => {
    schemas[id] = getSchema(id, dataMap);
  });

  return {
    ...state,
    schemas: { ...state.schemas, ...schemas },
    lastUpdated: action.receivedAt,
    error: null,
  };
}

function deleteDataMap(state, action) {
  const {
    requestInfo: { id: deletedId },
  } = action;
  const { listing, byId, docById, schemas, samplesById } = state;
  const filterFunction = (id) => id !== deletedId;

  const newDocById = { ...docById };
  delete newDocById[deletedId];

  const newSchemas = { ...schemas };
  delete newSchemas[deletedId];

  const newSamplesById = { ...samplesById };
  delete newSamplesById[deletedId];

  return {
    ...state,
    listing: filter(listing, filterFunction),
    byId: filter(byId, filterFunction),
    docById: newDocById,
    schemas: newSchemas,
    samplesById: newSamplesById,
    lastUpdated: action.receivedAt,
    error: null,
  };
}

function addDataMapSamples(state, action) {
  const {
    result: { output },
    requestInfo: { id },
    receivedAt,
  } = action;
  const { samplesById } = state;
  const samples = {
    ...initialState.samples,
    id,
    flat: output,
    lastUpdated: receivedAt,
  };

  return {
    ...state,
    samples,
    samplesById: {
      ...samplesById,
      [id]: samples,
    },
  };
}

function addSearchResults(state, action) {
  const {
    result,
    requestInfo: { id },
    receivedAt,
  } = action;
  const searchResults = {
    ...initialState.searchResults,
    id,
    lastUpdated: receivedAt,
  };

  if (!isEmpty(result)) {
    searchResults.flat = result;
  }

  return {
    ...state,
    searchResults,
  };
}

function handleUpdateSearchTerm(state, action) {
  const { payload } = action;

  if (!payload) {
    return clearSearchResults(state, action);
  }

  return state;
}

function clearSearchResults(state, action) {
  return {
    ...state,
    searchResults: initialState.searchResults,
  };
}

function saveDataMapDoc(state, action) {
  const {
    result,
    requestInfo: { id },
  } = action;

  return {
    ...state,
    docById: {
      [id]: isEmpty(result) ? null : result[0],
    },
  };
}
